import { Modal } from 'antd';

 const ModalComponent = ({_zIndex, _padding, _top, _className, _open, _onCancel,_title,_width,_height, _form,_maskClosable,_closable}) => {
    return (
        <div> 
        <Modal   
                  zIndex={_zIndex}
                  className={_className} 
                  title={_title}
                  open={_open}
                  onCancel={_onCancel}
                  footer={null}
                 width={_width}
                 height={_height}
                 style={{top:_top, padding:_padding}}
                 maskClosable={_maskClosable}
                 closable={_closable}
                  >
                    {_form}
              </Modal>
  </div>
    );
};


export default ModalComponent;